'use client';

import PropTypes from 'prop-types';
import Link from 'next/link';
import { useMemo } from 'react';
import { Box, Stack, Typography } from '@mui/material';
import { useSiteDocuments } from '@/contexts/SiteDocumentsContext';
import { mapSiteDocumentToFooterLink } from '@/utils/gallery-api';

function footerDocumentSort(a, b) {
  return (a.sortOrder ?? 0) - (b.sortOrder ?? 0);
}

export default function WebsiteFooterLegalLinks({ bottomFooterLinkSx, bottomFooterTextSx }) {
  const siteDocuments = useSiteDocuments();
  const links = useMemo(
    () =>
      (siteDocuments ?? [])
        .filter(doc => doc.showInFooter)
        .slice()
        .sort(footerDocumentSort)
        .map(mapSiteDocumentToFooterLink)
        .filter(Boolean),
    [siteDocuments],
  );

  return (
    <Stack
      direction="row"
      spacing={{ xs: 1, sm: 1.5 }}
      alignItems="center"
      justifyContent="center"
      flexWrap="wrap"
      useFlexGap
    >
      {links.map(({ label, href, openInNewTab }, index) => (
        <Stack key={label} direction="row" spacing={1.5} alignItems="center">
          {index > 0 ? (
            <Typography component="span" aria-hidden sx={{ ...bottomFooterTextSx, opacity: 0.5 }}>
              ·
            </Typography>
          ) : null}
          <Box
            component={Link}
            href={href}
            {...(openInNewTab ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
            sx={bottomFooterLinkSx}
          >
            {label}
          </Box>
        </Stack>
      ))}
    </Stack>
  );
}

WebsiteFooterLegalLinks.propTypes = {
  bottomFooterLinkSx: PropTypes.object,
  bottomFooterTextSx: PropTypes.object,
};
